<!-- eslint-disable vue/comment-directive -->

<template src='./IOTAddUpdate.html'></template>
<script>
import { CONTACT_NUMBER_LENGTH, MESSAGES } from "@/utils/constants";
import { notify, notifyApiError, notifyError, notifyWarn } from "@/utils/notification-helper";
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("iotExposer"); //importing store module
import FileUpload from "./FileUpload.vue";
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import FormGenerator from "@/components/Fields/FormGenerator";
//import { ConsoleLogger } from "@microsoft/signalr/dist/esm/Utils";
export default {
    components: {
        FileUpload,
        FormGenerator,
        'dropdownlist': DropDownList,

    },
    data: function () {
        return {
            add: this.$route.params.add,
            visibleDialog: false,
            fields: [
                { key: "Key" },
                { key: "Value" },
                "action"
            ],
            id: null,
            apiKey: null,
            name: null,
            tenantId: null,
            code: null,
            url: null,
            serviceType: [
                { text: 'pull', id: 1 },
                { text: 'push', id: 2 }
            ],
            serviceTypeId: null,

            header: [],
            headerKey: null,
            headerValue: null,

            parameter: [],
            key_2: null,
            value_2: null,

            allbody: [],
            deviceId: null,
            body_name: null,
            drivername: null,
            drivertel: null,
            ignchk: null,
            odo: null,
            lastseen: null,
            lat: null,
            lon: null,
            ign: null,
            immobilizeStatus: null,

            urlconfig: null,
            methodType: [
                { text: 'PUT', id: 1 },
                { text: 'POST', id: 2 }],

            synclocation: {},
            syncMode1: [{ text: 'Bulk', id: '1' }],
            syncType: [{ text: 'Active', id: '1' }],
            syncInterval: null,
            bulkDataLimit: null,

            syncConfig: {},
            configuration: {},

            methodTypeId: null,
            syncModeId: null,
            syncTypeId: null,
            syncLocation: {},

            expand: true,
            isEdit: false,
            isAdd: false,
            isDeleted: false,
            createdAt: null
        };
    },
    methods: {
        goToListPage: function () {
            this.$store.commit("iotExposer/cancel");
            this.$router.push({ name: "iotLanding" });
        },
        clearEntries: function () {
            this.apiKey = "",
                this.name = "",
                this.tenantId = "",
                this.code = "",
                this.url = "",

                this.deviceId = "",
                this.body_name = "",
                this.drivername = "",
                this.drivertel = "",
                this.ignchk = "",
                this.odo = "",
                this.lastseen = "",
                this.lat = "",
                this.lon = "",
                this.ign = "",
                this.immobilizeStatus = "",

                this.urlconfig = "",
                this.methodTypeId = "",

                this.headerKey = "",
                this.headerValue = "",

                this.key_2 = "",
                this.value_2 = "",

                this.fieldName = "",
                this.fieldValue = "",
                this.dataType = "",

                this.syncModeId = "",
                this.syncTypeId = "",
                this.syncInterval = "",
                this.bulkDataLimit = ""
        },

        onHeaderSubmit() {
            if (this.isAdd) {
                this.header.push({ key: this.headerKey, value: this.headerValue });
                this.clearForm();
                this.isAdd = false;
            } else if (!this.isAdd) {
                this.header.push({ key: this.headerKey, value: this.headerValue });
                this.clearForm();
            }
        },
        clearForm() {
            this.headerKey = "";
            this.headerValue = "";
        },

        onParameterSubmit() {
            if (this.isEdit) {
                this.parameter.push({ key: this.key_2, value: this.value_2 });
                this.clearParameterForm();
                this.isEdit = false;
            } else if (!this.isEdit) {
                this.parameter.push({ key: this.key_2, value: this.value_2 });
                this.clearParameterForm();
            }

        },
        clearParameterForm() {
            this.key_2 = "";
            this.value_2 = "";
        },
        addDevice: function () {
            const payload = {
                Id: this.id,
                ApiKey: this.apiKey ? this.apiKey : null,
                Name: this.name ? this.name : null,
                Code: this.code ? this.code : null,
                TenantId: this.tenantId.id ? this.tenantId.id : null,
                Url: this.url ? this.url : null,
                ServiceType: this.serviceTypeId.text ? this.serviceTypeId.text : null,
                Configuration: {
                    SyncLocation: {
                        url: this.urlconfig ? this.urlconfig : null,
                        methodType: this.methodTypeId.text ? this.methodTypeId.text : null,
                        header: this.header ? this.header : null,
                        parameter: this.parameter ? this.parameter : null,
                        Body: [
                            {
                                fieldName: 'deviceid',
                                fieldValue: this.deviceId.id ? this.deviceId.id : null,
                            },
                            {
                                fieldName: 'name',
                                fieldValue: this.body_name ? this.body_name : null
                            },
                            {
                                fieldName: 'drivername',
                                fieldValue: this.drivername ? this.drivername : null
                            },
                            {
                                fieldName: 'drivertel',
                                fieldValue: this.drivertel ? this.drivertel : null
                            },
                            {
                                fieldName: 'ignchk',
                                fieldValue: this.ignchk ? this.ignchk : null
                            },
                            {
                                fieldName: 'odo',
                                fieldValue: this.odo ? this.odo : null
                            },
                            {
                                fieldName: 'lastseen',
                                fieldValue: this.lastseen ? this.lastseen : null
                            },
                            {
                                fieldName: 'lat',
                                fieldValue: this.lat ? this.lat : null
                            },
                            {
                                fieldName: 'lon',
                                fieldValue: this.lon ? this.lon : null
                            },
                            {
                                fieldName: 'ign',
                                fieldValue: this.ign ? this.ign : null
                            },
                            {
                                fieldName: 'immobilizeStatus',
                                fieldValue: this.immobilizeStatus ? this.immobilizeStatus : null
                            }
                        ],
                    },
                    SyncConfig: {
                        SyncMode: this.syncModeId.text ? this.syncModeId.text : null,
                        SyncType: this.syncTypeId.text ? this.syncTypeId.text : null,
                        SyncInterval: this.syncInterval ? this.syncInterval : null,
                        BulkDataLimit: this.bulkDataLimit ? this.bulkDataLimit : null
                    }
                },
            }
            if (this.add) {
                this.$store
                    .dispatch("iotExposer/addDevice", payload)
                    .then((data) => {
                        if (data.status) {
                            notify(MESSAGES.RECORD_CREATE_SUCCESS);
                            this.goToListPage();
                            this.clearEntries();
                        } else {
                            notifyWarn(data.message);
                        }
                    })
                    .catch((err) => {
                        try {
                            notifyError(err.response.data.message);
                        } catch (error) {
                            notifyApiError({ message: "Something went wrong" });
                        }
                    });
            } else {
                this.$store
                    .dispatch("iotExposer/updateDevice", payload)
                    .then(() => {
                        notify(MESSAGES.CHANGES_SAVE_SUCCESS);
                        this.goToListPage();
                        this.clearEntries();
                    })
                    .catch(notifyApiError);
            }
        },
        validateDigits(e) {
            if ((e.target.value).length <= CONTACT_NUMBER_LENGTH) {
                this.simNumber = e.target.value
            }
        },
        editHeaderUpdate(event, index) {
            this.isHeaderValuesUpdate = event;
            this.isAdd = true;
            this.headerKey = this.header.filter((e) => e.key == event.key)[0].key;
            this.headerValue = this.header.filter((e) => e.key == event.key)[0].value;
            this.header.splice(index, 1);
        },
        confirmHeaderDeleteUpdate(index) {
            this.header.splice(index, 1);
        },
        confirmParameterDeleteUpdate(index) {
            this.parameter.splice(index, 1);
        },
        editParameterUpdate(event, index) {
            this.isParameterValuesUpdate = event;
            this.isEdit = true;
            this.key_2 = this.parameter.filter((e) => e.key == event.key)[0].key;
            this.value_2 = this.parameter.filter((e) => e.key == event.key)[0].value;
            this.parameter.splice(index, 1);
        },
        async getDataOnload() {
            if (!this.$route.params.add) {
                this.title = "Update Device";
                this.deviceEditData = this.$store.getters["iotExposer/getEditDevice"];
                this.apiKey = this.deviceEditData.apiKey;
                this.name = this.deviceEditData.name;
                this.tenantId = this.getCommonTenantTypes.find(i => i.id === this.deviceEditData.tenantId)
                this.code = this.deviceEditData.code;
                this.url = this.deviceEditData.url;
                this.serviceTypeId = this.serviceType.find(i => i.text === this.deviceEditData.serviceType);
                this.id = this.deviceEditData.id;
                this.urlconfig = this.deviceEditData.configuration.syncLocation.url;
                this.methodTypeId = this.methodType.find(i => i.text === this.deviceEditData.configuration.syncLocation.methodType);
                this.headerKey = '';
                this.headerValue = '';
                this.header = this.deviceEditData.configuration.syncLocation.header;
                // this.headerKey = this.deviceEditData.configuration.syncLocation.header.filter((el) => el.key)[0].key;
                // this.headerValue = this.deviceEditData.configuration.syncLocation.header.filter((el) => el.key)[0].value;
                this.key_2 = '';
                this.value_2 = '';
                // this.key_2 = this.deviceEditData.configuration.syncLocation.parameter.filter((el) => el.key)[0].key;
                // this.value_2 = this.deviceEditData.configuration.syncLocation.parameter.filter((el) => el.key)[0].value;
                this.parameter = this.deviceEditData.configuration.syncLocation.parameter;
                this.deviceId = this.getCommonDeviceTypes.find(i => i.id === this.deviceEditData.configuration.syncLocation.body.filter((el) => el.fieldName == 'deviceid')[0].fieldValue);
                this.body_name = this.deviceEditData.configuration.syncLocation.body.filter((el) => el.fieldName == 'name')[0].fieldValue;
                this.drivername = this.deviceEditData.configuration.syncLocation.body.filter((el) => el.fieldName == 'drivername')[0].fieldValue;
                this.drivertel = this.deviceEditData.configuration.syncLocation.body.filter((el) => el.fieldName == 'drivertel')[0].fieldValue;
                this.ignchk = this.deviceEditData.configuration.syncLocation.body.filter((el) => el.fieldName == 'ignchk')[0].fieldValue;
                this.odo = this.deviceEditData.configuration.syncLocation.body.filter((el) => el.fieldName == 'odo')[0].fieldValue;
                this.lat = this.deviceEditData.configuration.syncLocation.body.filter((el) => el.fieldName == 'lat')[0].fieldValue;
                this.lon = this.deviceEditData.configuration.syncLocation.body.filter((el) => el.fieldName == 'lon')[0].fieldValue;
                this.lastseen = this.deviceEditData.configuration.syncLocation.body.filter((el) => el.fieldName == 'lastseen')[0].fieldValue;
                this.ign = this.deviceEditData.configuration.syncLocation.body.filter((el) => el.fieldName == 'ign')[0].fieldValue;
                this.immobilizeStatus = this.deviceEditData.configuration.syncLocation.body.filter((el) => el.fieldName == 'immobilizeStatus')[0].fieldValue;
                this.bulkDataLimit = this.deviceEditData.configuration.syncConfig.bulkDataLimit;
                this.syncInterval = this.deviceEditData.configuration.syncConfig.syncInterval;
                this.syncModeId = this.syncMode1.find(i => i.text === this.deviceEditData.configuration.syncConfig.syncMode);
                this.syncTypeId = this.syncType.find(i => i.text === this.deviceEditData.configuration.syncConfig.syncType);
            } else {
                this.title = "Add Device";
            }
        },
        expandPanel() {
            let header = document.querySelectorAll('#panelbar .k-header');
            let element = document.querySelectorAll('#panelbar .k-content')[0];
            element.setAttribute('style', 'display:block !important');
            header[0].addEventListener('click', () => {
                if (element.getAttribute('style') == "display: block;") {
                    element.setAttribute('style', 'display:none !important');
                }
            });
        },
    },
    mounted() {
        this.expandPanel();
    },
    computed: {
        ...mapState(["initialData"]),
        getCommonDeviceTypes() {
            return this.initialData.deviceTypes
        },
        getCommonTenantTypes() {
            return this.initialData.tenants
        }
    },
    async beforeMount() {
        this.getDataOnload();
    },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {

    .k-form,
    .k-form-inline {
        font-size: 1rem;
        line-height: 1.5;
        padding: 1rem !important;
    }

    .page-header .title-text {
        font-size: 12px;
        margin-left: 10px;
    }

    .mobile_side_lbl {
        width: 70% !important;
    }

    .mobile_side_btn {
        display: flex;
    }

    .driver_header_mobile {
        flex-direction: row !important;
        overflow-x: auto;
        padding: 10px 10px 10px 10px;
    }
}

table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    margin-right: 60px;
}

td,
th {
    border: 2px solid #dddddd;
    padding: 10px;
    font-size: 15px;
}

tr:nth-child(even) {
    background-color: #dddddd;
}
</style>